import React from "react";
import Link from "next/link";
import styles from "./HowElixirSetsApart.module.scss";
import { getCDNImageUrl } from "@/utils/Common";

const PILL_ICON = "/assets/icons/elchemy-tech/feature-pill.svg";

const CARDS = [
  {
    heading: "AI for Chemical Procurement, Always On!",
    body: [
      "Describe your chemical manufacturing needs in plain language: Elixir's AI for procurement instantly surfaces the right chemical products, grades, and verified suppliers.",
      "From CAS number lookups to application-based filtering and compliance checks, the AI assistant understands technology for manufacturing so your procurement team never starts from scratch.",
    ],
    imageSide: "right",
    media: { type: "single", main: "feature-procurement.webp" },
  },
  {
    heading: "Clear Pricing for 50+ Ports",
    body: [
      "Stop chasing quotes. Elixir's AI for supply chain displays live, grade-specific pricing for every chemical - so your teams negotiate from knowledge, not guesswork.",
      "Explore fulfilment alternatives across grades, INCO terms, countries of origin, and lead times, all within one AI-powered platform.",
    ],
    imageSide: "left",
    cta: { label: "View Products", href: "/product" },
    media: {
      type: "single",
      variant: "pricingSingle",
      main: "feature-pricing-single.webp",
    },
  },
  {
    heading: "Smart Enquiry in Seconds",
    body: [
      "No lengthy RFQ forms. No back-and-forth emails. Elixir's AI for supply chain optimisation auto-fills quantity, destination, and target price, submitting directly to verified suppliers.",
      "From sample requests to bulk manufacturing orders, AI optimises every step with identical simplicity.",
    ],
    imageSide: "right",
    media: {
      type: "composite",
      variant: "enquiry",
      main: "feature-enquiry-a.webp",
      float: "feature-enquiry-b.webp",
    },
  },
];

function CardMedia({ media }) {
  const variantClass = media.variant ? styles[`media_${media.variant}`] : "";

  if (media.type === "single") {
    return (
      <div className={`${styles.media} ${variantClass}`}>
        <img
          src={getCDNImageUrl(media.main)}
          alt=""
          className={styles.mediaMain}
          loading="lazy"
        />
      </div>
    );
  }
  return (
    <div className={`${styles.media} ${styles.mediaComposite} ${variantClass}`}>
      <img
        src={getCDNImageUrl(media.main)}
        alt=""
        className={styles.mediaMain}
        loading="lazy"
      />
      <img
        src={getCDNImageUrl(media.float)}
        alt=""
        className={styles.mediaFloat}
        loading="lazy"
      />
    </div>
  );
}

function HowElixirSetsApart() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>
            How Elixir Sets Us Apart in Chemical Industry
          </h2>
          <p className={styles.subtitle}>
            Purpose-built AI for supply chain optimisation, procurement
            automation, and real-time pricing intelligence: streamlining every
            operation for manufacturers, buyers, and distributors globally.
          </p>
        </div>

        {/* Cards */}
        <div className={styles.cards}>
          {CARDS.map((card, i) => (
            <article
              key={i}
              className={`${styles.card} ${
                card.imageSide === "left" ? styles.imageLeft : ""
              }`}
            >
              <div className={styles.text}>
                <img src={PILL_ICON} alt="" className={styles.pill} />
                <h3 className={styles.cardHeading}>{card.heading}</h3>
                {card.body.map((p, j) => (
                  <p className={styles.cardBody} key={j}>
                    {p}
                  </p>
                ))}
                {card.cta && (
                  <Link href={card.cta.href} className={styles.cardCta}>
                    {card.cta.label}
                  </Link>
                )}
              </div>
              <CardMedia media={card.media} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowElixirSetsApart;
